import get from "lodash/get";
import merge from "lodash/merge";
import some from "lodash/some";
import moment from "moment";

import ChatActions from "../../actions/ChatActions";
import alt from "../../alt/ChatAlt";
import * as chatFactory from "../../utils/chat/chatFactory";
import MessageType from "../../constants/ChatMessageTypes";
import QuestionType from "../../constants/ChatQuestionTypes";

export class QuestionStore {
    constructor() {
        this.bindActions(ChatActions);
        this.bindListeners({
            onReset: [ChatActions.askQuestion, ChatActions.resetChat],
            onUpdate: [
                ChatActions.autoResponseReplySuccess,
                ChatActions.loadSuccess,
                ChatActions.responseAcceptSuccess,
                ChatActions.responseRateSuccess,
                ChatActions.reviewMarkAsResolvedSuccess,
                ChatActions.updateContactSuccess,
            ],
        });
        this.question = {};
        this.messages = [];
    }

    onReset() {
        this.setState({
            question: {},
            messages: [],
        });
    }

    onUpdate({ question }) {
        this.setState({
            question: chatFactory.buildQuestion(question),
            messages: this.buildMessages(question.messages),
        });
    }

    onReroute() {
        const question = merge({}, this.question, {
            reroutingStatus: {
                reroutedByPoster: true,
                rerouted: false,
                reroutedDate: moment.now(),
                showEscalationPromptToUser: false,
            },
            isInteractionAllowed: !this.question.closeQuestionWhenEscalated,
        });

        this.setState({ question });
    }

    onRerouteFail() {
        this.question.reroutingStatus.reroutedByPoster = false;
        this.question.reroutingStatus.rerouted = false;
        this.question.reroutingStatus.showEscalationPromptToUser = true;
        this.question.isInteractionAllowed = true;
    }

    onRerouteSuccess({ question }) {
        this.question.reroutingStatus.reroutedDate = question.reroutingStatus.reroutedDate;
    }

    buildMessages(rawMessages) {
        return rawMessages.map(message =>
            chatFactory.buildMessage({
                actions: message.actions,
                author: chatFactory.buildAuthor(message.author),
                dateCreated: message.dateCreated,
                id: message.id,
                lastUpdated: message.lastUpdated,
                messageText: message.body,
                type: message.type,
                viewedByUser: message.viewedByUser,
            })
        );
    }

    static getQuestion() {
        return this.getState().question;
    }

    static questionIsReroutedByPoster() {
        return (
            get(this.getState(), "question.reroutingStatus.rerouted", false) &&
            get(this.getState(), "question.reroutingStatus.reroutedByPoster", false)
        );
    }

    static questionIsReroutedByExpert() {
        return (
            get(this.getState(), "question.reroutingStatus.rerouted", false) &&
            get(this.getState(), "question.reroutingStatus.reroutedByExpert", false)
        );
    }

    static questionIsReroutedByTimeout() {
        return (
            get(this.getState(), "question.reroutingStatus.rerouted", false) &&
            get(this.getState(), "question.reroutingStatus.reroutedByInactivity", false)
        );
    }

    static questionIsReroutedByLanguage() {
        return (
            get(this.getState(), "question.reroutingStatus.rerouted", false) &&
            get(this.getState(), "question.reroutingStatus.reroutedByLanguage", false)
        );
    }

    static questionIsRerouted() {
        return (
            this.questionIsReroutedByPoster() ||
            this.questionIsReroutedByExpert() ||
            this.questionIsReroutedByTimeout() ||
            this.questionIsReroutedByLanguage()
        );
    }

    static getMessages() {
        return this.getState().messages;
    }

    static isOneOnOne() {
        return this.getQuestion().type === QuestionType.OneOnOneQuestion;
    }

    static hasContactInfoPrompt() {
        return some(this.getState().messages, { type: MessageType.ContactInfoPromptSystemMessage });
    }
}

export default alt.createStore(QuestionStore, "QuestionStore");
